var exports = {
  "jw": "SearchFilterChip.module__chip___MHdFcH",
  "xA": "SearchFilterChip.module__chipActive___MHdFcH",
  "mD": "SearchFilterChip.module__chipIcon___MHdFcH",
  "s5": "SearchFilterChip.module__chipContent___MHdFcH",
  "Zl": "SearchFilterChip.module__chipLabel___MHdFcH",
  "$j": "SearchFilterChip.module__chipLabelActive___MHdFcH",
  "ET": "SearchFilterChip.module__chipValue___MHdFcH",
  "cG": "SearchFilterChip.module__chipValueActive___MHdFcH",
  "DT": "SearchFilterChip.module__removeButton___MHdFcH",
};

module.exports = exports;
